// extracted by mini-css-extract-plugin
module.exports = {"v-application":"Search_v-application_3-Fa6","text-h1":"Search_text-h1_2QUsx","text-h2":"Search_text-h2_Rmn-n","search":"Search_search_l0shn"};